import { useSplitEnabled } from '@buffer-mono/features'

import { ThreadWithNoDragAndDrop, DragDropThread } from './thread/index'
import type { ThreadComponentProps } from './thread/types'

const Thread = (props: ThreadComponentProps) => {
  const { isEnabled: isDragDropEnabled } = useSplitEnabled(
    'composer-rearrange-threaded-posts',
  )

  return isDragDropEnabled ? (
    <DragDropThread {...props} />
  ) : (
    <ThreadWithNoDragAndDrop {...props} />
  )
}

export default Thread
